import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TokenService } from 'src/app/Services/token.service';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import * as myGlobals from '../../../app.component';
import { FacultyService } from 'src/app/Services/faculty.service';
import { HodService } from 'src/app/Services/hod.service';
import { StudentService } from 'src/app/Services/student.service';
import { StudentServiceService } from 'src/app/Services/Student-Service/student-service.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MenuService],
})
export class SidenavComponent implements OnInit {
  public psConfig: PerfectScrollbarConfigInterface = {
    wheelPropagation: true,
  };
  public menuItems: Array<any>;
  public settings: Settings;
  instituteMenuItems: any;
  payload: any;
  email: any;
  isInstitute: boolean;
  appId: any;
  isModerator: boolean;
  isStudent: boolean;
  isAdmin: boolean;
  isFaculty: boolean;
  isHod: boolean;
  isFinance: boolean;
  isConsultant: boolean;

  // Faculty Details
  facultyDetails: any;
  profilepath: any;
  profileImg:any;
  baseFileUrl = myGlobals.baseFileUrl;

  // HOD Details
  hodDetails: any;

  constructor(
    public appSettings: AppSettings,
    public menuService: MenuService,
    private token: TokenService,
    private facultyService: FacultyService,
    private hodService:HodService,
    private student: StudentServiceService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.menuItems = this.menuService.getVerticalMenuItems();
    this.payload = this.token.payload(localStorage.getItem('token'));

    const role = this.payload['role_id'];
    this.email = this.payload['email'];

    switch (role) {
      case 1: {
        this.isAdmin = true;
        this.menuItems = this.menuService.getVerticalMenuItemsAdmin();
        break;
      }
      case 2: {
        break;
      }
      case 3: {
        break;
      }
      case 4: {
        this.isModerator = true;
        this.menuItems = this.menuService.getModeratorVerticalMenuItems();
        break;
      }
      case 5: {
        this.isInstitute = true;
        this.menuItems = this.menuService.getInstituteVerticalMenuItems();
        break;
      }
      case 6: {
        this.student.getBasicDetails().subscribe(data =>{
          if(data['details']['profile_pic']){
            this.profilepath = data['details']['profile_pic']
            this.profileImg=this.baseFileUrl+"/student_basic_details/profile/"+this.profilepath;
          }else{
            this.profileImg=null;
          }
        });
        this.isStudent = true;
        this.menuItems = this.menuService.getVerticalMenuItemsStudent();
        break;
      }
      case 7:{
        this.hodService.getHodDetails().subscribe(response => {
          this.hodDetails = response['hodDetail'];
          this.profilepath = this.hodDetails['profile_pic'];
          this.profileImg=this.baseFileUrl+"/hod_profile_pic/"+this.profilepath;
        })
        this.isHod = true;
        this.menuItems = this.menuService.getVerticalMenuItemsHod();
        break;
      }
      case 8:{
        this.facultyService.getFacultyDetails().subscribe(response => {
          this.facultyDetails = response['facultyDetail'];
          if(this.facultyDetails['profile_pic']){
            this.profilepath = this.facultyDetails['profile_pic'];
            this.profileImg=this.baseFileUrl+"/faculty_profile_pic/"+this.profilepath;
          }else{
            this.profileImg=null;
          }
        })
        this.isFaculty = true;
        this.menuItems = this.menuService.getVerticalMenuItemsFaculty();
        break;
      }
      case 9:{
        this.isFinance = true;
        this.menuItems = this.menuService.getVerticalMenuItemsFinance();
        break;
      }
      case 11:{
        this.isConsultant = true;
        this.menuItems = this.menuService.getVerticalMenuItemsConsultant();
        break;
      }
      default: {

      }
    }
  }

  ngDoCheck() {
    if (this.settings.fixedSidenav) {
      if (this.psConfig.wheelPropagation == true) {
        this.psConfig.wheelPropagation = false;
      }
    } else {
      if (this.psConfig.wheelPropagation == false) {
        this.psConfig.wheelPropagation = true;
      }
    }
  }

  public closeSubMenus() {
    let menu = document.getElementById('vertical-menu');
    if (menu) {
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if (child) {
          if (child.children[0].classList.contains('expanded')) {
            child.children[0].classList.remove('expanded');
            child.children[1].classList.remove('show');
          }
        }
      }
    }
  }
}
